import PropTypes from 'prop-types';
import { flexRender } from '@tanstack/react-table';

import { DownOutlined } from '@ant-design/icons';
import { alpha, useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import CellRender from 'src/components/ui/CellRender';

const RowRender = (props) => {
	const {
		cells = [],
		depth,
		subCount,
		expandable,
		isExpanded,
		onToggleExpand,
	} = props;
	const theme = useTheme();
	const backColor = alpha(theme.palette.primary[200], 0.1);
	const hoverBackColor = alpha(theme.palette.primary[200], 0.2);

	return (
		<TableRow
			sx={{
				...(depth > 0
					? {
						bgcolor: backColor,
					}
					: {}),
				'&:hover': { bgcolor: `${hoverBackColor} !important` },
			}}
		>
			{cells.map((cell, i) => {
				const rt = cell.column.columnDef.renderType;
				const ExpandLabel =
					expandable && cell.column.columnDef.ExpandLabel;

				const RenderComp =
					rt === undefined ? cell.column.columnDef.cell : CellRender;

				const isNoBorder = i < cells.length - 1 && depth > 0;

				return (
					<TableCell
						key={cell.id}
						{...cell.column.columnDef.meta}
						sx={{
							...cell.column.columnDef.meta?.sx,
							py: depth > 0 ? 1 : 2,
							borderColor: isNoBorder ? backColor : undefined,
						}}
					>
						<Stack>
							{flexRender(RenderComp, cell.getContext())}
							{ExpandLabel && (
								<Box>
									<Typography
										variant="body2"
										color="secondary"
										component="span"
										onClick={onToggleExpand}
										sx={{ cursor: 'pointer', mb: -1 }}
									>
										<ExpandLabel
											count={subCount}
											isExpanded={isExpanded}
										/>
										<DownOutlined
											style={{
												position: 'relative',
												transformOrigin: '50%',
												marginLeft: 2,
												fontSize: '10px',
												lineHeight: 1,
												transition: '.2s transform',
												...(isExpanded
													? {
														transform:
																'rotate(180deg)',
													}
													: {}),
											}}
										/>
									</Typography>
								</Box>
							)}
						</Stack>
					</TableCell>
				);
			})}
		</TableRow>
	);
};

RowRender.propTypes = {
	cells: PropTypes.arrayOf(PropTypes.any), // Array of react-table cells https://tanstack.com/table/v8/docs/api/core/cell
	expandable: PropTypes.bool,
	isExpanded: PropTypes.bool,
	subCount: PropTypes.number,
	depth: PropTypes.number,
	CellRender: PropTypes.elementType,
	onToggleExpand: PropTypes.func,
};

export default RowRender;
